import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Button, useTheme, CircularProgress, Hidden
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { getFiliadosMaisLucrativos, getVisitasPorMes } from '../../../../../services/DashboardService';
import  Chart  from 'react-apexcharts'
import {IOSSwitch}  from '../../../../../components/'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { FaMedal, FaUser, FaExternalLinkAlt } from 'react-icons/fa'
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { geetFiliadoPorIdFiliado } from '../../../../../services/FiliadoService';
import { Values } from '../../../../../values/Values';


const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 20,
    maxHeight: 550,
    minHeight: 550
  },
  chartContainer: {
    height: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const ListagemFiliadosMaisLucrativos = props => {
  const {
    className,
    history,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    ...rest } = props;
  const theme = useTheme();
  const [filiadosMaisLucrativos, setFiliadosMaisLucrativos] = useState([]);
  const [mostrarProgress, setMostrarProgress] = useState(true);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);
  const [mostrarAnaliseDetalhada, setMostrarAnaliseDetalhada] = useState(true);

  const classes = useStyles();

  useEffect(() => {
    try {
      getDados();
    }
    catch (e) {

    }
  }, []);

  async function getDados() {
    try {
      setMostrarProgress(true);
      let dados = await getFiliadosMaisLucrativos();
      if (dados.isSuccess) {
        setMostrarProgress(false);
        setFiliadosMaisLucrativos(dados.result);
      } else {
        setMostrarProgress(false);
        setMostrarAlertaErro(true);
      }
    } catch (e) {
      setMostrarProgress(false);
      setMostrarAlertaErro(true);
    }
  }

  async function abrirEdicaoFiliado(idFiliado) {
    try {
      setLoading(true);
      let filiado = await geetFiliadoPorIdFiliado(idFiliado);
      setLoading(false);
      if(filiado.isSuccess) {
        if(filiado.result.length > 0) {
          history.push('/filiado-edit/', {filiado: filiado.result[0], edicao: true});
        }
        else {
          setTypeSnack('warning');
          setMessageSnack('Não foi possível obter os dados do filiado.')
          setShowMessageSnack(true);
        }
      }
      else {
        setTypeSnack('error');
        setMessageSnack(filiado.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch)
      setShowMessageSnack(true);
    }
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      elevation={3}
      style={{
        minHeight: 500
      }}
    >
      <CardHeader
        title="Filiados mais lucrativos"
      />
      <CardContent>
        <Grid
          container
        >
          {
            mostrarProgress &&
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  height: 400,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <CircularProgress
                />
              </Grid>
            </Grid>
          }
          {
            mostrarAnaliseDetalhada && !mostrarProgress &&
            <Grid
              item
              md={12}
              xs={12}
            >
              <List className={classes.root} dense={true}>
                {
                  !mostrarProgress &&
                  filiadosMaisLucrativos.map((filiado, index) => {
                    return (
                      <div
                        key={filiado.idFiliado}
                      >
                        <ListItem
                          key={filiado.idFiliado}
                        >
                          <ListItemAvatar>
                            {
                              index === 0 ?
                                <Avatar style={{backgroundColor: theme.palette.warning.main}}>
                                  <FaMedal />
                                </Avatar>
                                :
                                <Avatar >
                                  <FaUser/>
                                </Avatar>

                            }

                          </ListItemAvatar>
                          <ListItemText
                            primary={filiado["filiado.nome"]}
                            secondary={
                              <React.Fragment>
                                <Typography
                                  component="span"
                                  variant="body2"
                                  className={classes.inline}
                                  color="textPrimary"
                                >
                                  {`Valor total gasto: ${(filiado.valorTotal ? filiado.valorTotal : 0).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}`}
                                </Typography>
                              </React.Fragment>
                            }
                          />
                          <ListItemSecondaryAction>
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={e => abrirEdicaoFiliado(filiado["filiado.idFiliado"])}
                            >
                              <FaExternalLinkAlt size={'16px'}/>
                            </IconButton>
                          </ListItemSecondaryAction>
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </div>
                    );}
                  )
                }
              </List>
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

ListagemFiliadosMaisLucrativos.propTypes = {
  className: PropTypes.string
};

export default ListagemFiliadosMaisLucrativos;
